import { createUseStyles } from 'react-jss';

export default createUseStyles({
  loginContainer: {
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '52% 48%',
    gridTemplateRows: '144px 1fr',
    columnGap: '80px',
    backgroundColor: '#e8e8e8',

    '@media(max-width: 900px)': {
      display: 'initial',
    },
  },

  logosContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
    marginTop: '48px',
    marginLeft: '22%',
    '& > img:nth-of-type(1)': {
      height: '70px',
    },
    '& > img:nth-of-type(2)': {
      height: '40px',
    },
    '@media(max-width: 900px)': {
      marginTop: '20px',
      marginLeft: 0,
      width: '100%',
      flexDirection: 'column',
    },
  },

  infoImage: {
    gridColumn: '2/3',
    gridRow: '1/3',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    '& img': {
      width: '100%',
    },

    '@media(max-width: 900px)': {
      display: 'none',
    },
  },

  loginForm: {
    paddingTop: '72px',
    paddingLeft: '22%',
    paddingRight: '30%',
    '&>h1': {
      marginBottom: '30px',
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 'bold',
    },
    '&>p': {
      marginBottom: '30px',
      fontFamily: '"Manrope", sans-serif',
    },
    '@media(max-width: 900px)': {
      paddingTop: '30px',
      paddingLeft: '24px',
      paddingRight: '24px',
      '&>h1': {
        textAlign: 'center',
        marginBottom: '20px',
        fontSize: '2rem',
      },
      '&>p': {
        marginBottom: '20px',
      },
    },
  },

  formHelper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },

  rememberLink: {
    color: '#6D7883',
    fontSize: '14px',
    '&:hover': {
      textDecoration: 'none',
      color: '#257bfe',
    },
  },

  link: {
    marginTop: '16px',
    color: '#185ae8',
    '&:hover': {
      textDecoration: 'none',
      color: '#257bfe',
    },
  },

  button: {
    width: '100%',
    margin: '48px 0',
    '@media(max-width: 900px)': {
      margin: '0 0 20px 0',
    }
  },

  text: {
    color: '#6D7883',
    fontSize: '14px',
    textAlign: 'center',
  },

  version: {
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
});
